import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AssessmentDurationCalendarComponent } from './assessment-duration-calendar.component';
import { NgbCalendarModule } from '../ngb-calendar/ngb-calendar.module';

@NgModule({
  imports: [CommonModule, FormsModule, NgbModule, NgbCalendarModule],
  declarations: [AssessmentDurationCalendarComponent],
  exports: [AssessmentDurationCalendarComponent],
})
export class AssessmentDurationCalendarModule {}
